import { IconProps } from '../icon';

export function LogoWhiteIcon(props: IconProps) {
  return (
    <svg
      id="Groupe_5939"
      data-name="Groupe 5939"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="396.7"
      height="81.587"
      viewBox="0 0 396.7 81.587"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_388"
            data-name="Rectangle 388"
            width="396.7"
            height="81.587"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Groupe_5939-2" data-name="Groupe 5939" clipPath="url(#clipPath)">
        <path
          id="Tracé_572"
          data-name="Tracé 572"
          d="M80.062,64.91,113.787,51.93l-.043-38.938L80.13,0,46.33,12.986V51.924ZM52,16.937a1.173,1.173,0,0,1,.754-1.095L79.7,5.491a1.177,1.177,0,0,1,.847,0l26.794,10.351.037.019a1.057,1.057,0,0,1,.2.105c.012.006.025.025.037.031.031.025.056.049.087.074a1.162,1.162,0,0,1,.148.155.806.806,0,0,1,.062.093,1.972,1.972,0,0,1,.1.2l.037.093a1.126,1.126,0,0,1,.049.322l.037,30.924a.673.673,0,0,1,.006.111,1.174,1.174,0,0,1-1.175,1.175h-.006a1.1,1.1,0,0,1-.42-.08L81.261,39.328V58.194c0,.037.006.074.006.111a1.174,1.174,0,0,1-1.175,1.175h-.006a1.1,1.1,0,0,1-.42-.08L52.755,49.073a1.181,1.181,0,0,1-.754-1.1Z"
          transform="translate(-17.681)"
          fill="#fff"
        />
        <path
          id="Tracé_573"
          data-name="Tracé 573"
          d="M98.969,60.046l.019,14.791v1.979l-1.843.711L63.42,90.507l-1.033.4-1.033-.4L27.622,77.527l-1.843-.711V60.04C10.16,64.5,0,71.752,0,79.933,0,93.5,27.919,104.5,62.362,104.5s62.362-11,62.362-24.568c-.006-8.175-10.154-15.416-25.755-19.887"
          transform="translate(0 -22.913)"
          fill="#fff"
        />
        <path
          id="Tracé_574"
          data-name="Tracé 574"
          d="M102.78,39.6v8.731l24.531,9.436-.031-27.61Z"
          transform="translate(-39.224 -11.51)"
          fill="#fff"
        />
        <path
          id="Tracé_575"
          data-name="Tracé 575"
          d="M59.3,52.008l24.537,9.436V32.121a1.178,1.178,0,0,1,.754-1.1l9-3.469,15-5.782L85.067,12.68,59.3,22.586Z"
          transform="translate(-22.631 -4.839)"
          fill="#fff"
        />
        <path
          id="Tracé_576"
          data-name="Tracé 576"
          d="M251.258,36.66a15.888,15.888,0,0,0-10.988-4.4c-10.011,0-15.138,7.328-15.088,15.237,0,8.057,5.126,15,15.088,15a15.4,15.4,0,0,0,10.4-3.958V48.965H238.754V46.671h14.408V59.465a17.648,17.648,0,0,1-12.893,5.516c-11.625,0-17.63-8.107-17.63-17.432-.049-10.7,7.229-17.679,17.63-17.679A17.791,17.791,0,0,1,252.773,35Z"
          transform="translate(-84.967 -11.399)"
          fill="#fff"
        />
        <path
          id="Tracé_577"
          data-name="Tracé 577"
          d="M310.071,64.849H306.6L294.785,51.907H285.46V64.849h-2.64V30.66h15.045c7.42,0,11.186,5.324,11.236,10.648.049,5.565-3.617,10.45-11.087,10.45ZM285.454,49.415h12.114c5.961,0,8.6-3.37,8.645-8.156.049-4.007-2.684-8.156-8.348-8.156h-12.4V49.415Z"
          transform="translate(-107.934 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_578"
          data-name="Tracé 578"
          d="M336.581,46.435H356.6v2.393H336.581v13.48h21.587v2.541H333.99V30.66h23.591v2.492h-21Z"
          transform="translate(-127.462 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_579"
          data-name="Tracé 579"
          d="M385.075,46.435H405.1v2.393H385.075v13.48h21.587v2.541H382.49V30.66h23.584v2.492h-21Z"
          transform="translate(-145.971 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_580"
          data-name="Tracé 580"
          d="M433.839,30.66l23,28.278V30.66h2.591V64.849h-1.026L435.354,36.621V64.849H432.72V30.66Z"
          transform="translate(-165.141 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_581"
          data-name="Tracé 581"
          d="M514.5,30.858,499.312,47.22l16.455,17.24v.39h-7.958L493.5,49.706V64.849h-6.45V30.66h6.45V45.117L506.491,30.66H514.5Z"
          transform="translate(-185.875 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_582"
          data-name="Tracé 582"
          d="M566.245,30.74V50.324c0,10.11-6.2,15.286-14.8,15.286-8.206,0-15.187-4.984-15.187-15.286V30.74h6.394V50.324c0,6.153,3.518,9.424,8.836,9.424s8.348-3.562,8.348-9.424V30.74Z"
          transform="translate(-204.655 -11.731)"
          fill="#fff"
        />
        <path
          id="Tracé_583"
          data-name="Tracé 583"
          d="M622.6,40.579a6.943,6.943,0,0,1-4.446,6.592c4.007,1.224,5.473,5.473,5.473,7.618,0,7.618-5.714,10.061-12.794,10.061H594.62V30.66h16.214c6.74,0,11.768,3.03,11.768,9.919m-21.63,3.809h9.863c4.057,0,5.374-1.713,5.374-3.661,0-1.564-1.268-4.2-5.374-4.2h-9.863Zm0,14.451h9.863c2.64,0,6.4-.878,6.4-4.1,0-3.079-3.76-4.687-6.4-4.687h-9.863Z"
          transform="translate(-226.928 -11.701)"
          fill="#fff"
        />
        <path
          id="Tracé_584"
          data-name="Tracé 584"
          d="M224.94,100.77h8.366v1.416h-6.845v3.5h6.326v1.336h-6.326v3.908h6.963V112.3H224.94Z"
          transform="translate(-85.845 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_585"
          data-name="Tracé 585"
          d="M249.833,100.77v1.373H245.95V112.3h-1.577v-10.16H240.49V100.77h9.343"
          transform="translate(-91.779 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_586"
          data-name="Tracé 586"
          d="M269.07,100.77h1.564v10.16h5.788V112.3h-7.346V100.77Z"
          transform="translate(-102.686 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_587"
          data-name="Tracé 587"
          d="M283.77,100.77h8.366v1.416h-6.845v3.5h6.326v1.336h-6.326v3.908h6.963V112.3H283.77Z"
          transform="translate(-108.296 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_588"
          data-name="Tracé 588"
          d="M317.107,108.868a4.854,4.854,0,0,1-.433,2.269,3.152,3.152,0,0,1-3.049,1.478,3.524,3.524,0,0,1-2.214-.7,2.976,2.976,0,0,1-.921-2.5v-.822h1.466v.822a2.082,2.082,0,0,0,.421,1.416,1.665,1.665,0,0,0,1.311.476,1.61,1.61,0,0,0,1.639-.853,5.64,5.64,0,0,0,.235-1.985V100.78h1.546Z"
          transform="translate(-118.494 -38.461)"
          fill="#fff"
        />
        <path
          id="Tracé_589"
          data-name="Tracé 589"
          d="M327.787,100.77h1.762l4.186,11.533h-1.713l-1.206-3.457h-4.526l-1.249,3.457h-1.6Zm2.591,6.8-1.775-5.1-1.843,5.1Z"
          transform="translate(-123.436 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_590"
          data-name="Tracé 590"
          d="M342.666,100.77h5.244a5.164,5.164,0,0,1,2.133.383,2.731,2.731,0,0,1,1.6,2.727,2.824,2.824,0,0,1-1.626,2.752,2.345,2.345,0,0,1,1.014.723,2.627,2.627,0,0,1,.383,1.453l.056,1.546a4.681,4.681,0,0,0,.111.983.96.96,0,0,0,.5.7v.26h-1.917a1.55,1.55,0,0,1-.124-.383,8.259,8.259,0,0,1-.08-.909l-.093-1.923a1.626,1.626,0,0,0-.816-1.515,3.275,3.275,0,0,0-1.367-.21h-3.457v4.947H342.66V100.77Zm5.077,5.281a2.927,2.927,0,0,0,1.694-.439,1.811,1.811,0,0,0,.625-1.583,1.718,1.718,0,0,0-.872-1.682,2.8,2.8,0,0,0-1.243-.235h-3.71v3.939h3.506"
          transform="translate(-130.771 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_591"
          data-name="Tracé 591"
          d="M361.26,100.77h4.607a4.329,4.329,0,0,1,3.642,1.688,6.3,6.3,0,0,1,1.156,3.9,7.91,7.91,0,0,1-.68,3.321,4.2,4.2,0,0,1-4.131,2.622H361.26Zm4.3,10.2a4.1,4.1,0,0,0,1.274-.167,2.8,2.8,0,0,0,1.459-1.175,4.815,4.815,0,0,0,.649-1.787,7.217,7.217,0,0,0,.117-1.212,5.714,5.714,0,0,0-.835-3.327,3.046,3.046,0,0,0-2.684-1.187h-2.708v8.855Z"
          transform="translate(-137.869 -38.457)"
          fill="#fff"
        />
        <rect
          id="Rectangle_385"
          data-name="Rectangle 385"
          width="1.577"
          height="11.533"
          transform="translate(235.282 62.313)"
          fill="#fff"
        />
        <path
          id="Tracé_592"
          data-name="Tracé 592"
          d="M387.14,100.77h1.843l5.751,9.319V100.77h1.49V112.3h-1.756L388.63,103V112.3h-1.49Z"
          transform="translate(-147.746 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_593"
          data-name="Tracé 593"
          d="M417.18,100.77h4.607a4.328,4.328,0,0,1,3.642,1.688,6.3,6.3,0,0,1,1.156,3.9,7.91,7.91,0,0,1-.68,3.321,4.2,4.2,0,0,1-4.131,2.622H417.18Zm4.3,10.2a4.1,4.1,0,0,0,1.274-.167,2.8,2.8,0,0,0,1.459-1.175,4.815,4.815,0,0,0,.649-1.787,7.217,7.217,0,0,0,.117-1.212,5.714,5.714,0,0,0-.835-3.327,3.046,3.046,0,0,0-2.684-1.187h-2.708v8.855Z"
          transform="translate(-159.21 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_594"
          data-name="Tracé 594"
          d="M436.09,100.77h8.367v1.416h-6.845v3.5h6.326v1.336h-6.326v3.908h6.963V112.3H436.09Z"
          transform="translate(-166.427 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_595"
          data-name="Tracé 595"
          d="M453.605,100.77l3.314,9.82,3.271-9.82h1.75l-4.2,11.533h-1.657l-4.2-11.533h1.725"
          transform="translate(-172.453 -38.457)"
          fill="#fff"
        />
        <rect
          id="Rectangle_386"
          data-name="Rectangle 386"
          width="1.577"
          height="11.533"
          transform="translate(291.312 62.313)"
          fill="#fff"
        />
        <path
          id="Tracé_596"
          data-name="Tracé 596"
          d="M477.99,100.77h8.366v1.416h-6.845v3.5h6.326v1.336h-6.326v3.908h6.969V112.3H478V100.77Z"
          transform="translate(-182.418 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_597"
          data-name="Tracé 597"
          d="M495.1,100.77h1.843l5.751,9.319V100.77h1.49V112.3h-1.756L496.59,103V112.3H495.1Z"
          transform="translate(-188.947 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_598"
          data-name="Tracé 598"
          d="M521.664,100.77v1.373H517.78V112.3H516.2v-10.16H512.32V100.77h9.344"
          transform="translate(-195.519 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_599"
          data-name="Tracé 599"
          d="M540.84,100.77h2.238l3.314,9.752,3.3-9.752h2.22V112.3h-1.49v-6.808q0-.352.019-1.169c.012-.544.019-1.125.019-1.75l-3.29,9.727H545.62l-3.327-9.727v.352c0,.284.006.711.025,1.292s.025,1,.025,1.274V112.3h-1.49V100.77Z"
          transform="translate(-206.403 -38.457)"
          fill="#fff"
        />
        <path
          id="Tracé_600"
          data-name="Tracé 600"
          d="M565.317,100.77h1.762l4.186,11.533h-1.713l-1.206-3.457h-4.526l-1.249,3.457h-1.6Zm2.591,6.8-1.775-5.1-1.843,5.1Z"
          transform="translate(-214.086 -38.457)"
          fill="#fff"
        />
        <rect
          id="Rectangle_387"
          data-name="Rectangle 387"
          width="1.577"
          height="11.533"
          transform="translate(358.943 62.313)"
          fill="#fff"
        />
        <path
          id="Tracé_601"
          data-name="Tracé 601"
          d="M587.875,108.4a3.288,3.288,0,0,0,.445,1.6,2.907,2.907,0,0,0,2.64,1.144,4.554,4.554,0,0,0,1.546-.254,1.767,1.767,0,0,0,1.348-1.744,1.526,1.526,0,0,0-.569-1.342,5.641,5.641,0,0,0-1.812-.68l-1.515-.352a6.607,6.607,0,0,1-2.1-.761,2.431,2.431,0,0,1-1.064-2.158,3.37,3.37,0,0,1,1.045-2.554,4.117,4.117,0,0,1,2.962-1,5.027,5.027,0,0,1,3,.878,3.193,3.193,0,0,1,1.237,2.8h-1.466a2.96,2.96,0,0,0-.482-1.422,2.744,2.744,0,0,0-2.325-.9,2.6,2.6,0,0,0-1.9.581,1.866,1.866,0,0,0-.581,1.348,1.337,1.337,0,0,0,.686,1.243,9.933,9.933,0,0,0,2.028.631l1.564.371a4.775,4.775,0,0,1,1.75.73,2.766,2.766,0,0,1,1.064,2.35,2.943,2.943,0,0,1-1.36,2.739,5.974,5.974,0,0,1-3.16.822,4.635,4.635,0,0,1-3.284-1.1,3.747,3.747,0,0,1-1.163-2.962h1.466Z"
          transform="translate(-223.794 -38.278)"
          fill="#fff"
        />
        <path
          id="Tracé_602"
          data-name="Tracé 602"
          d="M613.594,102.22a6.336,6.336,0,0,1,1.144,3.914,6.86,6.86,0,0,1-1.311,4.291,5.193,5.193,0,0,1-4.39,2.01,5.266,5.266,0,0,1-4.186-1.756,6.659,6.659,0,0,1-1.36-4.285,6.817,6.817,0,0,1,1.162-4,5.037,5.037,0,0,1,4.409-2.133,5.293,5.293,0,0,1,4.533,1.96m-1.379,7.352a6.279,6.279,0,0,0,.921-3.407,4.859,4.859,0,0,0-1.064-3.277,3.624,3.624,0,0,0-2.906-1.243,3.775,3.775,0,0,0-2.919,1.231,5.183,5.183,0,0,0-1.132,3.624,5.282,5.282,0,0,0,.971,3.234,3.637,3.637,0,0,0,3.141,1.317,3.239,3.239,0,0,0,2.987-1.478"
          transform="translate(-230.313 -38.263)"
          fill="#fff"
        />
        <path
          id="Tracé_603"
          data-name="Tracé 603"
          d="M624.69,100.77h1.843l5.751,9.319V100.77h1.49V112.3h-1.756L626.18,103V112.3h-1.49Z"
          transform="translate(-238.403 -38.457)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default LogoWhiteIcon;
